module.exports = {
  // TODO: Figure out which fields are actually needed here then remove the rest from all properties
  gatsbyConfig: {
    property: 'rendezvan',
    copyrightTagline: 'RendezVan',
    siteName: 'RendezVan',
    siteUrl: 'https://www.rendezvan.com/',
    reCaptchaDBPropertyName: 'Rendezvan',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    color: '#64CAC7',
    facebook: 'mtbachelorfanpage',
    instagram: 'MtBachelor',
    youtube: 'mtbachelor',
    dynamicTypes: [
      'pressRelease',
      'event',
      'blog',
    ],
  },
  // TODO: Good way of managing API keys per site, maybe use for formbucket and mailchimp?
  contentfulConfig: {
    spaceId: '38vc2unmqsq5',
    accessToken: 'D2b0ZG2uKbPvWdW38GS0y3_hQN9AxH-iJnKijjoI0cA',
  },
};
